import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "HOME", path: "/", testid: "nav-home-link", x: 472 },
  { label: "ABOUT", path: "/about", testid: "nav-about-link", x: 600 },
  { label: "HISTORY", path: "/history", testid: "nav-history-link", x: 736 },
  { label: "SHOWS", path: "/shows", testid: "nav-shows-link", x: 890 },
];

const MOBILE_LINKS = [
  ...NAV,
  { label: "ZAN-O-BOX", path: "/zan-o-box", testid: "nav-zanobox-link" },
];

const STRIP_STYLE = {
  backgroundImage: "url('/assets/header-bg.jpg')",
  backgroundSize: "cover",
  backgroundPosition: "center",
};

export const HeaderNav = () => {
  const [open, setOpen] = useState(false);

  return (
    <header data-testid="site-header">
      {/* Desktop — exact 1440px PDF canvas */}
      <div className="bg-header-strip hidden lg:block" style={STRIP_STYLE}>
        <div className="canvas-1440 relative hidden h-[146px] lg:block">
          <Link to="/" data-testid="brand-logo-link" aria-label="B. Cooper Studios — home">
            <img
              src="/assets/logo.png"
              alt="B. Cooper Studios"
              className="absolute left-[17px] top-[28px] w-[329px]"
            />
          </Link>
          <img
            src="/assets/topbar.png"
            alt=""
            aria-hidden="true"
            className="absolute left-[283px] top-[40px] w-[1157px]"
          />
          <nav aria-label="Primary">
            {NAV.map((l) => (
              <NavLink
                key={l.path}
                to={l.path}
                end={l.path === "/"}
                data-testid={l.testid}
                className={({ isActive }) =>
                  `absolute top-[90px] text-[18px] uppercase leading-[25px] tracking-[0.06em] text-[#2B2822] transition-colors duration-300 hover:text-[#4E8A63] ${
                    isActive ? "font-bold" : "font-normal"
                  }`
                }
                style={{ left: `${l.x}px` }}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
          <Link
            to="/zan-o-box"
            data-testid="nav-zanobox-link"
            aria-label="Zan-o-Box"
            className="absolute left-[1110px] top-[86px] block h-[52px] w-[211px]"
          />
        </div>
      </div>

      {/* Mobile / tablet */}
      <div className="bg-header-strip sticky top-0 z-40 shadow-[0_2px_10px_rgba(40,38,32,0.25)] lg:hidden" style={STRIP_STYLE}>
        <div className="flex items-center justify-between px-4 py-2.5 sm:px-6">
          <Link to="/" data-testid="brand-logo-link-mobile" aria-label="B. Cooper Studios — home">
            <img src="/assets/logo.png" alt="B. Cooper Studios" className="h-11 w-auto" />
          </Link>
          <button
            data-testid="mobile-menu-toggle"
            aria-label={open ? "Close menu" : "Open menu"}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center border-2 border-[#85A697] text-[#2B2822] transition-colors duration-300 hover:bg-[#85A697] hover:text-white"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
        <AnimatePresence>
          {open && (
            <motion.nav
              data-testid="mobile-menu"
              aria-label="Mobile"
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
              className="overflow-hidden border-t border-[#85A697]/50"
            >
              <div className="flex flex-col gap-1 px-6 py-5">
                {MOBILE_LINKS.map((l, i) => (
                  <motion.div
                    key={l.path}
                    initial={{ opacity: 0, x: -14 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.05 * i, duration: 0.3 }}
                  >
                    <NavLink
                      to={l.path}
                      end={l.path === "/"}
                      data-testid={`mobile-${l.testid}`}
                      onClick={() => setOpen(false)}
                      className={({ isActive }) =>
                        `block py-2.5 text-sm uppercase tracking-[0.25em] ${
                          isActive ? "font-bold text-[#2B2822]" : "text-[#2B2822]/75"
                        }`
                      }
                    >
                      {l.label}
                    </NavLink>
                  </motion.div>
                ))}
              </div>
            </motion.nav>
          )}
        </AnimatePresence>
      </div>
    </header>
  );
};
